function musicOff({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9299 5.0692H15.9299V1.0692H9.92993V5.6792L11.9299 7.6792V5.0692ZM9.92993 8.5092L2.33993 0.929199L0.929932 2.3392L9.92993 11.3392V11.6192C8.98993 11.0792 7.82993 10.8692 6.59993 11.2992C5.25993 11.7792 4.22993 12.9692 3.98993 14.3692C3.52993 17.1092 5.84993 19.4492 8.57993 19.0192C10.5399 18.7092 11.9299 16.9092 11.9299 14.9192V13.3392L17.6599 19.0692L19.0699 17.6592L9.92993 8.5092ZM7.92993 17.0692C6.82993 17.0692 5.92993 16.1692 5.92993 15.0692C5.92993 13.9692 6.82993 13.0692 7.92993 13.0692C9.02993 13.0692 9.92993 13.9692 9.92993 15.0692C9.92993 16.1692 9.02993 17.0692 7.92993 17.0692Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default musicOff;
